"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFE = void 0;
var MFE;
(function (MFE) {
    MFE["SELECT_GLOBAL_CUSTOMERS"] = "SELECT_GLOBAL_CUSTOMERS";
    MFE["ADD_TO_RECIPIENT_LIST"] = "ADD_TO_RECIPIENT_LIST";
    MFE["CLEAR_RECIPIENT_LIST_AND_SELECTED_CUSTOMERS"] = "CLEAR_RECIPIENT_LIST_AND_SELECTED_CUSTOMERS";
})(MFE || (exports.MFE = MFE = {}));
//# sourceMappingURL=index.js.map